import { FunctionComponent, useEffect, useState } from "react";
import PageLayout from "@components/core/layouts/PageLayout";
import { useTranslation } from "react-i18next";
import CardSection from "@components/core/section/CardSection";
import { Spin } from "antd";
import parse from "html-react-parser";
import { columns } from "@views/core/extranet/signature/columns/SignatorySignatureSuccessColumns";
import BasicTable from "@components/core/tables/BasicTable";
import { TransactionDetail } from "@/type/core/transaction/transaction.types";
import { requestGetTransactionSignatorySuccess } from "@/state/transactions/TransactionEffects";
import { useNavigate, useParams } from "react-router-dom";
import { ROUTES } from "@/routes/Routes";
import { toastError } from "@/utils/helpers/toast-helper";

const SignatorySignatureSuccessScreen: FunctionComponent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const idRequest = params.signatoryId;
  // TODO check this
  const hideDownloadText = params.hideDownloadText ?? false;

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [transactions, setTransactions] = useState<TransactionDetail[]>([]);

  useEffect(() => {
    if (!idRequest) {
      navigate(ROUTES.extranet.home.generate());
    } else {
      setIsLoading(true);
      void requestGetTransactionSignatorySuccess({
        dto: {
          excludeTransactionOfSignatory: idRequest,
        },
      });
    }
  }, [idRequest]);

  useEffect(() => {
    return requestGetTransactionSignatorySuccess.doneData.watch((response) => {
      if (response.ok && response.data) {
        setTransactions(response.data.transactions);
      } else {
        toastError(t("error.toast.accountData"));
      }
      setIsLoading(false);
    });
  });

  return (
    <PageLayout container bodyClassName="mt-0">
      <CardSection
        title={t("signature.success.title")}
        titleClassName="h1 mb-0"
      >
        <>
          <p>
            <strong className="text-success">
              {t("signature.success.text1")}
            </strong>
          </p>
          <p>{t("signature.success.text2")}</p>
          {!hideDownloadText && <p>{t("signature.success.text21")}</p>}
          {transactions && transactions.length !== 0 && (
            <h2 className="text-primary mt-48">
              {t("signature.success.nextSignature.title")}
            </h2>
          )}
          {transactions && transactions.length !== 0 && isLoading && (
            <div className="h-100 flex-grow-1 d-flex align-items-center justify-content-center mt-48">
              <Spin />
            </div>
          )}
          {transactions && transactions.length !== 0 && !isLoading && (
            <>
              <p>{parse(t("signature.success.nextSignature.body"))}</p>
              <div className="table-signature-success">
                <BasicTable
                  pagination={false}
                  columns={columns()}
                  dataSource={transactions}
                />
              </div>
            </>
          )}
        </>
      </CardSection>
    </PageLayout>
  );
};

export default SignatorySignatureSuccessScreen;
